import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    OnInit,
    signal,
    Signal,
    WritableSignal,
} from '@angular/core';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import {
    GridViewsModule,
    TableColumnDef,
} from '../../../../../../../projects/grid-views/src/public-api';
import { DataElementDto } from 'app/data-api';
import { MatTableDataSource } from '@angular/material/table';
import { DataElementsService } from 'app/modules/data-module/dictionary/data-elements/data-elements.service';

@Component({
    selector: 'select-data-element-dialog',
    imports: [GridViewsModule],
    templateUrl: './select-data-element-dialog.component.html',
    styleUrl: './select-data-element-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectDataElementDialogComponent
    extends DialogBuilderComponent<any>
    implements OnInit
{
    displayedColumns: Array<TableColumnDef>;
    data: WritableSignal<any> = signal([]);

    dataSource: Signal<MatTableDataSource<DataElementDto>> = computed(
        () => new MatTableDataSource(this.service.state())
    );
    selection: WritableSignal<any[]> = signal([]);

    constructor(private service: DataElementsService) {
        super();

        this.displayedColumns = this.service.getDisplayedColumns();

        effect(() => {
            const code = this.executeActionSignal();

            if (code === 'selectDataElement') {
                this.componentData.formControl.setValue(this.selection()[0].dataElement);
                this.closeDialog();
            }
        });
    }

    onRowSelected($event: any): void {
        if (!$event[0]) {
            return;
        }
        this.selection.set($event);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.service.getDataElements().toPromise();
    }
}
